// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import Field from './Field.js';
import { protect } from '../utils/protect.js';

const Paragraph = function ({ template, fields, color, style }) {

  const parts = [];
  let subTemplate = template;
  let match = /({\d+})/g.exec(subTemplate);
  while (match) {
    parts.push(subTemplate.substring(0, match.index));
    const index = parseInt(match[0].substring(1, match[0].length - 1));
    if (fields.length > index) {
      const field = fields[index];
      parts.push(
        <div>
          <Field
            value={field.value}
            type={field.type}
            translate={field.translate}
            variant={field.variant}
            color={protect(field.color, field.value)}
            style={protect(field.style, field.value)}
          />
        </div>
      );
    }
    else {
      parts.push('{' + index + '}');
    }
    subTemplate = subTemplate.substring(match.index + match[0].length);
    match = /({\d+})/g.exec(subTemplate);
  }
  parts.push(subTemplate);

  const classNameParts = [];
  if (color) {
    classNameParts.push('text-' + color);
  }
  if (style) {
    classNameParts.push(style);
  }
  if (classNameParts.length > 0) {
    return (
      <div className={classNameParts.join(' ')}>
        {parts.map(function (part, index) {
          return (<div key={index} className="d-inline-block pe-1">{part}</div>);
        })}
      </div>
    );
  }
  else {
    return (
      <div>
        {parts.map(function (part, index) {
          return (<div key={index} className="d-inline-block pe-1">{part}</div>);
        })}
      </div>
    );
  }
}

export default Paragraph;